<template>
  <GenericDialog :activator="showDialog" @close="showDialog = false">
    <FavLocationForm
      :initial-value="formInitialValue"
      @close="showDialog = false"
    />
  </GenericDialog>
</template>

<script setup lang="ts">
import { computed } from "vue";

import GenericDialog from "@/components/dialog-wrappers/GenericDialog.vue";
import type { processedAddressObj } from "@/domains/addressLookups/types.ts";
import SavedLocation from "@/domains/locations/savedLocation.ts";
import FavLocationForm from "./FavLocationForm.vue";

/**
 * Add-a-saved-location dialog. `initialValue` lines up with
 * `AddressAutocompleteInput`'s own `initialValue` prop so a caller that
 * already has a `processedAddressObj` in hand (e.g. a trip's selected
 * destination) can pass it straight through to pre-fill the address -
 * leave it unset for a blank add form.
 */
const { initialValue } = defineProps<{
  initialValue?: processedAddressObj;
}>();

const showDialog = defineModel<boolean>("showDialog", {
  required: true,
});

const formInitialValue = computed<SavedLocation | undefined>(() =>
  initialValue ? SavedLocation.fromProcessedAddressObj(initialValue) : undefined,
);
</script>
